angular.module('mercury.modules.reports.voids')
.controller('ReportsVoidReasonsCtrl', ["PosVoids", "ReportPosStaff", "$q", "reporttime", "$stateParams", "$scope", "title", function(PosVoids, ReportPosStaff, $q, reporttime, $stateParams, $scope, title) {
  if ($stateParams.staffId && $stateParams.staffName) {
    title.set('Voids Report For ' + $stateParams.staffName);
    $scope.loading = ReportPosStaff.getVoidsForStaff(reporttime.start(), reporttime.end(), $stateParams.staffId);
  } else {
    title.set('Voids Report');
    $scope.loading = PosVoids.getByReason(reporttime.start(), reporttime.end());
  }

  $scope.loading.then(function(results) {
    $scope.voids = results;
  });

  $scope.voidReasonsColumns = [
    {label: 'Void Reasons', type: 'string', key: 'voidReason'},
    {label: 'Amount', type: 'number', key: 'voidAmount', filter: 'currency'}
  ];
}]);
